import { jsx, jsxs } from 'react/jsx-runtime';
import { Children } from 'react';
import { LinkContainer } from './styles.js';

const BREADCRUMB_TEST_IDS = {
  CONTAINER: '@web/Breadcrumb/Container'
};
/**
 * Breadcrumb
 *
 * Takes component children and creates a series of links detailing the "path
 * taken" to the particular page we are on. Optionally, entries can be plain
 * text instead of a link. This is mostly used when the user is currently
 * viewing the page that breadcrumb would be linking to.
 */

/* eslint-disable react/no-danger */

const Breadcrumb = ({
  children,
  ...restProps
}) => jsx("div", Object.assign({
  className: "h-padding-h-tiny",
  "data-test": BREADCRUMB_TEST_IDS.CONTAINER
}, restProps, {
  children: Children.map(children, (child, i) => jsxs(LinkContainer, {
    children: [child, i < Children.count(children) - 1 ? jsx("span", Object.assign({
      "aria-hidden": "true",
      className: "h-padding-h-tiny"
    }, {
      children: "/"
    }), void 0) : jsx("span", {
      "aria-hidden": "true",
      dangerouslySetInnerHTML: {
        __html: '&#x200E;'
      }
    }, void 0)]
  }, i))
}), void 0);
Breadcrumb.displayName = 'Breadcrumb';

export { BREADCRUMB_TEST_IDS, Breadcrumb };
